var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.computedClass },
    [
      _vm.error
        ? _c("JadeIcon", {
            attrs: { use: "circle-alert", size: "small", color: "negative" },
          })
        : _vm._e(),
      _c(
        "JadeText",
        {
          attrs: {
            color: "current-color",
            variant: "text-small",
            weight: "regular",
          },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }